import React from "react";
import Alert from './Alert';
import _ from "lodash";

const ErrorMessageAlert = ({error, errorList, className}) => {
    const alertClassName = className !== undefined ? className : '';
    if (_.isEmpty(error)) {
        return '';
    }
    if (typeof error === 'string') {
        return (
            <Alert type="danger" content={error} className={alertClassName} />
        );
    }

    if (Array.isArray(error)) {
        return (
            <Alert type="danger" className={alertClassName}>
                <ul>
                    {error.map((item, index) => <li key={index}>{item}</li>)}
                </ul>
            </Alert>
        );
    }
    return '';
};

export default ErrorMessageAlert;
